export default __webpack_public_path__ + "static/media/landscape35.4a8bad6d.jpeg";